// @flow
import * as React from 'react';
import styled from 'styled-components';
import ArrowLeft from 'react-bootstrap-icons/dist/icons/arrow-left';
import X from 'react-bootstrap-icons/dist/icons/x';
import XCircleFill from 'react-bootstrap-icons/dist/icons/x-circle-fill';
import Search from 'react-bootstrap-icons/dist/icons/search';
import ShieldLockFill from 'react-bootstrap-icons/dist/icons/shield-lock-fill';
import ExclamationTriangle from 'react-bootstrap-icons/dist/icons/exclamation-triangle';
import InfoCircleFill from 'react-bootstrap-icons/dist/icons/info-circle-fill';
import CheckCircleFill from 'react-bootstrap-icons/dist/icons/check-circle-fill';
import ChevronRight from 'react-bootstrap-icons/dist/icons/chevron-right';

type TIconNames =
  | 'info-circle-fill'
  | 'x-circle-fill'
  | 'exclamation-triangle'
  | 'shield-lock-fill'
  | 'search'
  | 'arrow-left'
  | 'x'
  | 'check-circle-fill'
  | 'chevron-right';

type TProps = {
  name: TIconNames,
  color?: string,
  onClick?: () => void,
  size?: number,
};

const Button = styled.button`
  :hover { transform: scale(${props => props.onClick ? 1.1 : 1}); }
  :active { transform: scale(0.98); }
  transition: 50ms ease;
  background-color: transparent;
  background-repeat:no-repeat;
  border: none;
  cursor: ${props => props.onClick ? 'pointer' : undefined};
  overflow: hidden;
  padding: 0;
  display: flex;
  outline: ${props => props.onClick ? undefined : 'none'};
  color: ${props => props.color || '#000'};
`;

function getIcon(name: TIconNames): { Component: React.Component<{}>, size: number } {
  return ({
    'arrow-left': { Component: ArrowLeft, size: 22 },
    'x': { Component: X, size: 28 },
    'x-circle-fill': { Component: XCircleFill, size: 12 },
    'search': { Component: Search, size: 14 },
    'shield-lock-fill': { Component: ShieldLockFill, size: 18 },
    'exclamation-triangle': { Component: ExclamationTriangle, size: 18 },
    'info-circle-fill': { Component: InfoCircleFill, size: 18 },
    'check-circle-fill': { Component: CheckCircleFill, size: 18 },
    'chevron-right': { Component: ChevronRight, size: 18 },
  })[name];
}


export default function ButtonIcon(props: TProps): React.Node {
  const { Component, size } = getIcon(props.name);
  return (
    <Button onClick={props.onClick || undefined}>
      {/* $FlowFixMe */}
      <Component size={props.size || size} color={props.color} />
    </Button>
  );
}
